<div>
    <input
        [placeholder]="placeholder"
        type="text"
        #searchInput
        (input)="ngSelect.filter(searchInput.value)"
        (keydown)="handleKeydown($event)"
    />
    <i class="icon-dku-search"></i>
</div>